import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
const NotificationPage = () => {
  return (
    <table className="w-[1300px] max-lg:w-full  p-6 max-md:p-2 mx-auto py-12 mt-6 rounded-2xl shadow-2xl backdrop-blur-2xl flex justify-start items-center flex-col gap-3">
      <h1 className="text-3xl max-md:text-xl opacity-0 animate-[showtitle_1s_forwards] text-start w-full text-white mb-6 uppercase font-semibold">
        ծանուցումներ
      </h1>
      <tr className="flex w-full opacity-0 animate-[showtitle_1s_forwards] p-3 justify-between items-center rounded-[20px] shadow-2xl bg-white">
        <td className="w-max flex justify-start items-center">
          <img
            className="w-[80px] max-md:w-[60px] max-md:h-[60px] h-[80px] bg-gray-300 rounded-xl"
            src=""
            alt=""
          />
        </td>
        <td className="w-max flex justify-center max-md:flex-col max-md:items-start items-center">
          <h1 className="text-2xl max-md:text-lg">Company Name</h1>
          <h1 className="text-xl md:hidden max-md:text-sm">Title Notification</h1>
        </td>
        <td className="w-[40%] max-md:hidden flex justify-center items-center">
          <h1 className="text-xl max-md:text-sm">Title Notification</h1>
        </td>
        <td className="w-max flex justify-center max-md:hidden items-center">
          <h1 className="text-xl  max-md:text-sm">30.10.25</h1>
        </td>
        <td className="w-max flex justify-center max-md:flex-col max-md:items-start items-center">
          <h1 className="text-xl md:hidden  max-md:text-sm">30.10.25</h1>
          <h1 className="text-xl max-md:text-sm">18:57</h1>
        </td>
        <td className="w-max flex justify-center items-center">
          <button className="w-[40px] bg-red-600 text-white h-[40px] flex justify-center items-center rounded-full">
            <FontAwesomeIcon icon={faTrash} />
          </button>
        </td>
      </tr>
    </table>
  );
};
export default NotificationPage;
